import React from 'react'
import Demo from "../../innerpages/Demo";

const DemoBanner = () => {
    return <Demo/>
}

export default DemoBanner;